import React from 'react';
import { Grid, Link } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { BasicDialog, Text, PrimaryButton } from 'library';
import { NextStepsModalProps, NextStepType, APP_LINK } from '../IndeedModels';
import LogoTextPair from './LogoTextPair';
import { Colors } from '../../../../constants';
import usePublicSessionTracking, { PublicSessionEventType } from '../../../shared/PublicSessionTracking';
import DownloadIcon from 'assets/icons/indeed-home/download.svg';
import LoginIcon from 'assets/icons/indeed-home/log-in-sharp.svg';
import ManageIcon from 'assets/icons/indeed-home/manage-jobs.svg';
import AppStore from 'assets/icons/app_store_black.svg';

export const JOBS_SCREEN = require('assets/icons/indeed-home/jobs-screen-copy-2.png');

const NextStepsModal = ({ isOpen, setIsOpen }: NextStepsModalProps) => {
    const { trackSession } = usePublicSessionTracking('Next Steps Dialog');

    const nextSteps: NextStepType[] = [
        {
            icon: <DownloadIcon />,
            text: "We'll text you a link to download the app.",
            title: 'Download the app.',
        },
        {
            icon: <LoginIcon />,
            text:
                'You already have an account!  Enter the login information you just added here and the job will be waiting for you on the app.',
            title: 'Log in.',
        },
        {
            icon: <ManageIcon />,
            text:
                'The job will be waiting for you in the app.  Message about the job and apply ot other jobs on the app!',
            title: 'Manage jobs on app.',
        },
    ];

    const handleDownloadClick = (source: string) => {
        trackSession('NAVIGATE_FROM', `To App Store - ${source}`, PublicSessionEventType.User, { link: APP_LINK });
        if (source === 'Button') {
            window.open(APP_LINK, '_blank');
        }
    };

    const handleOnClose = () => {
        setIsOpen(false);
        trackSession('DIALOG_CLOSE', 'Next Steps', PublicSessionEventType.User);
    };

    return (
        <BasicDialog isOpen={isOpen} onClose={handleOnClose} closeButton={true}>
            <Grid container direction="row">
                {!isMobile ? (
                    <Grid
                        item
                        container
                        direction="column"
                        xs={5}
                        spacing={3}
                        style={{ maxWidth: 250, paddingRight: 30 }}
                    >
                        <Grid item>
                            <img src={JOBS_SCREEN} alt="" style={{ width: '100%' }} />
                        </Grid>
                        <Grid item>
                            <Link href={APP_LINK} target="_blank" onClick={() => handleDownloadClick('Icon')}>
                                <AppStore />
                            </Link>
                        </Grid>
                    </Grid>
                ) : null}
                <Grid item container direction="row" xs={isMobile ? 12 : 7} style={{ width: '100%' }}>
                    <Grid item style={{ marginTop: 30 }} xs={12}>
                        <Text
                            variant="body1"
                            color={Colors.turquoise}
                            textStyle={{ letterSpacing: 2.2, fontSize: 12 }}
                            bold
                        >
                            YOU'RE SO CLOSE
                        </Text>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 25 }}>
                        <Text variant="display" textStyle={{ fontSize: 26 }}>
                            Here are next steps:
                        </Text>
                    </Grid>
                    {nextSteps.map((nextStep) => {
                        return (
                            <LogoTextPair
                                icon={nextStep.icon}
                                text={nextStep.text}
                                key={nextStep.text}
                                title={nextStep.title}
                                gridStyle={{ marginBottom: 25 }}
                            />
                        );
                    })}
                    <Grid item xs={12} style={{ marginBottom: isMobile ? 25 : 0 }}>
                        <PrimaryButton
                            onClick={() => handleDownloadClick('Button')}
                            textStyle={{ fontWeight: 'bold', fontSize: 14 }}
                        >
                            Download the Tandem App
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </BasicDialog>
    );
};

export default NextStepsModal;
